import type { HbBidderConfig } from '../types'

export const APS_ACCOUNT_ID = 'aff2f88f-029a-4051-97cc-2453bc61d867'

export const APS: HbBidderConfig = {
    bidder: 'aps',
    params: {},
}
